export const DIALOG_LARGE = {
  width: '100%',
  minWidth: 500,
  maxWidth: 1000,
};
